export default "__VITE_ASSET__hLcyFvZp__"